import { Star } from "lucide-react";
const Stars = ({ rating }) => {
  return (
    <div className="flex gap-1 items-start pr-4">
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          size={20}
          className={
            star <= Math.floor(rating)
              ? "fill-yellow-400 text-yellow-400"
              : "text-gray-300"
          }
        />
      ))}
    </div>
  );
};

export default Stars;
